import circleCross from './circleCross'
import circleTick from './circleTick'

const Icons = {
  circleCross,
  circleTick,
}
export default Icons